import upsell from "../upsell"
import { TrackingManager } from "../../../../../lib/common/js/services/tracking/trackingManager"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...upsell("premium"),

  internalTracker: new TrackingManager(
    window.trackingConfig.enabledTrackingServices,
    pipelineConfig,
  ),

  init() {
    this.commonInit()
  },

  onInit() {
    this.initUpsell()
  },

  handleOfferAccept() {
    this.internalTracker.trackClick({ clickName: "Premium Accepted Clicked" })
    this.purchase()
  },

  handleOfferDecline() {
    this.internalTracker.trackClick({ clickName: "Premium Rejected Clicked" })
    this.goToNextUpsellOffer(true)
  },
})
